export enum ParameterTypeEnum {
    GridData = 1
}
